module.exports = __webpack_public_path__ + "fonts/6dc72ad9-779c-4857-acb7-2ef161563863.c0866842.eot";